module.exports = __webpack_public_path__ + "img/Stephen Universe.66f4d6a7.jpg";